import { useRouter } from 'next/router';

import { PdpCatalogFulfillmentType } from '../graphql/select-option_types.2';
import { useOptions } from '../queries/useOptions';

export const useSelectOptionService = () => {
  const router = useRouter();
  const isPreview = router.asPath.split('/')[2] === '__preview';

  const {
    options,
    options: {
      catalog_product: { fulfillment_type, matching_catalog_product_info, meta_catalog_product_info },
      flags: { is_purchase_only_one_at_time },
    },
  } = useOptions();

  const is_store_zigzin_product = fulfillment_type === PdpCatalogFulfillmentType.VENDOR_FLEX;
  const is_zigzin_product = fulfillment_type === PdpCatalogFulfillmentType.ZIGZIN;
  const is_zigzin_matching_product = is_zigzin_product && !!matching_catalog_product_info;
  const isGeneralMatchingProduct = !is_zigzin_product && !!matching_catalog_product_info;
  const has_store_zigzin_option =
    is_store_zigzin_product ||
    matching_catalog_product_info?.fulfillment_type === PdpCatalogFulfillmentType.VENDOR_FLEX;

  return {
    isPreview,
    meta_catalog_product_info,
    options,
    has_store_zigzin_option,
    is_zigzin_product,
    is_zigzin_matching_product,
    isGeneralMatchingProduct,
    isPurchaseOnlyOneAtTime: Boolean(is_purchase_only_one_at_time),
  };
};
